import { FC } from 'react';
import { IBlock } from '../../shared/interfaces/IBlock';
import { Box, Rating, Typography, useTheme } from '@mui/material';
import Helper from '../../shared/helpers/Helper';
import { Trans, useTranslation } from 'react-i18next';

const Block: FC<IBlock> = ({ rating, text, title }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const canDisplayText = (input?: string | null): boolean => {
    if (Helper.isNullOrUndefined(input)) return false;
    return !(typeof input === 'string' && input.trim().length === 0);
  };

  return (
    <Box
      sx={{
        my: theme.spacing(0.5),
        py: theme.spacing(0.5),
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {canDisplayText(title) && (
        <Typography
          variant="body1"
          sx={{ fontWeight: theme.typography.fontWeightLight }}
        >
          <Trans t={t}>{title}</Trans>
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          pt: theme.spacing(1),
        }}
      >
        {typeof rating === 'number' && rating > 0 && (
          <Rating
            name="read-only"
            value={rating}
            max={5}
            precision={0.5}
            readOnly
          />
        )}
        {canDisplayText(text) && (
          <Typography
            variant="body2"
            sx={{ mt: theme.spacing(1), fontWeight: theme.typography.fontWeightLight }}
          >
            {text}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Block;
